export const getBaseUrl = () => `https://${getDomain()}`
export const getDomain = () => process.env.GATSBY_DOMAIN

/** Autodesk Workshop XR marketing entry (HTTPS). */
export const WORKSHOP_XR_INTRO_URL =
  'https://workshopxr.autodesk.com/introduction'

/** Official Autodesk Workshop XR product overview (HTTPS). */
export const WORKSHOP_XR_OVERVIEW_URL =
  'https://www.autodesk.com/products/workshop-xr/overview'
